<template>
    <div class="login-container">
        <div class="login-content clearfix">
            <div class="login-main clearfix">
                <div class="login-info">
                    <div class="login-info-img">
                        <img src="https://chuangpei-prod.oss-cn-hangzhou.aliyuncs.com/images/png_login_picture%402x.png" alt="">
                    </div>
                </div>
                <div class="login-entrance">
                    <div class="login-entrance-title">登录</div>
                    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" auto-complete="on" label-position="left">
                        <el-form-item prop="username" label="账号">
                            <el-input v-model="loginForm.username" placeholder="请输入账号" name="username" type="text" tabindex="1"
                                    auto-complete="on"/>
                        </el-form-item>
                        <el-form-item prop="password" label="密码">
                            <el-input
                            v-model="loginForm.password"
                            placeholder="请输入密码"
                            name="password"
                            :type="passwordType ? 'text' : 'password'"
                            tabindex="2"
                            auto-complete="on"
                            @keypress.native.enter="handleLogin">
                            <i slot="suffix" class="iconfont"
                            :class="passwordType ? 'icon-xianshimima' : 'icon-yincangmima'"
                            @click="handleType"></i>
                            </el-input>
                        </el-form-item>
                        <el-button :loading="loading" type="primary" @click.native.prevent="handleLogin">登录</el-button>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { login } from '@/api/login/index'
import { setToken, setrefToken, setExpires, setloginTime, setuserInfo } from '@/utils/auth'

export default {
    name: 'login',
    data() {
        const validateUsername = (rule, value, callback) => {
            if (!value) {
            callback(new Error('请输入账号'))
            } else {
            callback()
            }
        }
        const validatePassword = (rule, value, callback) => {
            if (!value) {
            callback(new Error('请输入密码'))
            } else {
            callback()
            }
        }
        return {
            loginForm: {
                grant_type: 'password',
                username: '',
                password: ''
            },
            passwordType: false,
            loginRules: {
                username: [
                    { required: true, trigger: 'blur', validator: validateUsername }
                ],
                password: [
                    { required: true, trigger: 'blur', validator: validatePassword }
                ]
            },
            loading: false
        }
    },
    methods: {
        handleLogin() {
            this.$refs.loginForm.validate((valid) => {
                if (valid) {
                    this.loading = true
                    login(this.loginForm).then(res => {
                        if (res.code === 0) {
                            const data = res.data
                            const loginTime = new Date().getTime()
                            const getToken = data.token.token_type + ' ' + data.token.access_token
                            const getrefToken = data.token.token_type + ' ' + data.token.refresh_token
                            const getExpires = data.token.expires_in
                            const userInfo = data.user_info
                            setToken(getToken)
                            setrefToken(getrefToken)
                            setExpires(getExpires)
                            setloginTime(loginTime)
                            setuserInfo(JSON.stringify(userInfo))
                            location.reload()
                        }
                        this.loading = false
                    }).catch(res => {
                        this.loading = false
                    })
                } else {
                    return false
                }
            })
        },
        handleType() {
            this.passwordType = !this.passwordType
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/styles/variables.scss";
  .login-container {
    width: 100%;
    height: 100%;
    .login-content {
      position: relative;
      width: 100%;
      height: 100%;
      min-width: 1000px;
      min-height: 570px;
      background: #F7F8FB;
      background: url('https://chuangpei-prod.oss-cn-hangzhou.aliyuncs.com/images/bg_login.png') no-repeat;
      background-size: cover;
      .login-main {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 1000px;
        height: 568px;
        box-shadow: 0px 14px 40px 0px rgba(0, 95, 255, 0.64);
        background-color: #F3F5F9;
        .login-info {
          position: relative;
          float: left;
          width: 50%;
          height: 100%;
          .login-info-img {
            position: absolute;
            left: 50%;
            top: 50%;
            margin-left: -220px;
            margin-top: -149px;
            width: 441px;
            height: 298px;
            img {
              display: block;
              width: 100%;
              height: 100%;
            }
          }
        }
        .login-entrance {
          float: left;
          width: 50%;
          height: 100%;
          background: #FFFFFF;
          padding: 112px 88px;
          box-sizing: border-box;
          .login-entrance-title {
            font-size: 24px;
            font-weight: bold;
            color: #171717;
            line-height: 24px;
            margin-bottom: 52px;
          }

          ::v-deep .el-form {
            .el-form-item {
              margin-bottom: 12px;

              .el-form-item__label {
                font-size: 16px;
                font-weight: 500;
                color: #171717;

                &:before {
                  display: none;
                }
              }
              .el-input--suffix{
                .el-input__suffix{
                  right: 12px;
                  top: 3px;
                  cursor: pointer;
                  .iconfont{
                    color: #A3A4B3;
                    font-size: 24px;
                  }
                  &:hover{
                    .iconfont{
                      color: $primaryColor;
                    }
                  }
                }
              }
              .el-input {
                input:-webkit-autofill {
                  -webkit-box-shadow: 0 0 0 1000px white inset; /**通过边框阴影遮挡住背景*/
                  -webkit-text-fill-color: #333;
                }

                .el-input__inner {
                  border-radius: 4px;
                  height: 48px;
                  border: 1px solid #DCDFE6;
                  &::placeholder {
                    color: #909399;
                  }

                  &:hover {
                    border-color: $primaryColor;
                  }
                }
              }

              &.is-error {
                .el-input {
                  .el-input__inner {
                    border-color: #E94D41;
                  }
                }
              }
            }

            .el-button {
              width: 100%;
              height: 48px;
              margin-top: 26px;
              background: $primaryColor;
              border-radius: 4px;
              font-size: 16px;
              color: #fff;
              letter-spacing: 4px;

              .el-icon-loading {
                font-size: 16px;
              }

              &:hover {
                opacity: 0.75;
              }
            }
          }
        }
      }
    }
  }
</style>
